import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, azureDatabricksResourceIdFormat, azureDatabricksResourceIdErrorMessage, getDatabricksControls } from './shared-control-metadata';

export const azureDatabricksMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Databricks/workspaces',
    connectionSuffix: 'privateConnections',
    resourceIdValidator: azureDatabricksResourceIdFormat,
    groupIdMetadata: {
        databricks_ui_api: {
            linkedServiceType: 'AzureDatabricks',
            groupId: 'databricks_ui_api',
            iconClass: 'svg-i_databricks_16x16',
            displayName: stringResources.AzureDataBricks_DisplayText,
            controls: {
                creationControls: getDatabricksControls(),
                readonlyControls: getReadonlyControl(azureDatabricksResourceIdFormat, azureDatabricksResourceIdErrorMessage)
            }
        }
    }
};
